// extracted by mini-css-extract-plugin
export default {"main":"connect_main__yJlMz","spin":"connect_spin__FPXbj","loaderImg":"connect_loaderImg__uvh0B"};